import { SVToast } from '@/components/core';
import { SVToastData } from '@/types/common';
import { toast } from 'react-toastify';

type ShowToastProps = {
  type: 'error' | 'info' | 'warning' | 'success';
  data: SVToastData;
  autoClose?: number | false;
};

export default function showToast({
  type,
  data,
  autoClose = 5000,
}: ShowToastProps) {
  const { content, title, buttons } = data;
  const baseToastOptions = {
    closeOnClick: buttons?.length ? false : true,
    data: {
      content,
      title,
      buttons,
    },
  };
  switch (type) {
    case 'error':
      toast.error(SVToast, {
        autoClose: false,
        ...baseToastOptions,
      });
      break;
    case 'info':
      toast.info(SVToast, {
        autoClose,
        ...baseToastOptions,
      });
      break;
    case 'warning':
      toast.warn(SVToast, {
        autoClose,
        ...baseToastOptions,
      });
      break;
    default:
      toast.success(SVToast, {
        autoClose,
        ...baseToastOptions,
      });
  }
}
